import { getCookie } from '../cookie';

export function useToken() {
  const fromStorage = localStorage.getItem('token');
  if (fromStorage) return fromStorage;

  const fromCookie = getCookie('token');
  if (fromCookie) {
    localStorage.setItem('token', fromCookie);
    return fromCookie;
  }

  return null;
}
